export function removeInvalidKey(query) {
  if (typeof query === 'object' && query) {
    for (var key in query) {
      try {
        if (query[key] == null) delete query[key];
      } catch (ex) {}
    }
  }
  return query;
}
